import { useEffect, useRef } from 'react';

/**
 * 专门解决 React Strict Mode 下 useEffect 执行两次的问题
 * 保证副作用函数只执行一次
 * @param effect 副作用函数
 */
export const useEffectOnce = (effect: () => void | (() => void)) => {
  const effectCalled = useRef(false);
  const renderAfterCalled = useRef(false);
  const destroyFunc = useRef<void | (() => void)>(undefined);

  if (effectCalled.current) {
    renderAfterCalled.current = true;
  }

  useEffect(() => {
    // 只有第一次时执行
    if (!effectCalled.current) {
      destroyFunc.current = effect();
      effectCalled.current = true;
    }

    // 清理函数
    return () => {
      // 如果组件在 effect 执行后没有重新渲染（即 Strict Mode 的立即卸载），则不执行清理
      // 只有在真正的卸载时才执行清理
      if (!renderAfterCalled.current) {
        return;
      }
      if (destroyFunc.current) {
        destroyFunc.current();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
